module.exports = __webpack_public_path__ + "img/polizeifahrt.cad2ce9b.jpg";